;(function () {
  'use strict'

  angular
    .module('contrast.freemium.registration')
    .controller('FreemiumActivationCtrl', [
      '$scope',
      '$routeParams',
      '$location',
      'freemiumRegistrationService',
      'policy',
      FreemiumActivationCtrl
    ])

  function FreemiumActivationCtrl(
    $scope,
    $routeParams,
    $location,
    freemiumRegistrationService,
    policy
  ) {
    var token = $routeParams.freemiumToken
    angular.extend($scope, {
      resetting: false,
      model: {
        password: '',
        confirmpassword: '',
        passwordvalid: false,
        policy: angular.copy(policy)
      }
    })

    angular.extend($scope, {
      save: save
    })

    function save() {
      $scope.resetting = true
      freemiumRegistrationService
        .activate(token, $scope.model.password)
        .then(function () {
          $location.path('/pages/signin', true)
        })
        .catch(function (data) {
          if (data.status == 400) {
            $location.path('/pages/signin', true)
          }
        })
        .finally(function () {
          $scope.resetting = false
        })
    }
  }
})()
